import { render, staticRenderFns } from "./MinHacienda.vue?vue&type=template&id=306350e1&scoped=true&"
var script = {}
import style0 from "./MinHacienda.vue?vue&type=style&index=0&id=306350e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306350e1",
  null
  
)

export default component.exports